export class OAuthRequiredScopesMissingError extends Error {
  constructor() {
    super();
    this.name = 'OAuthRequiredScopesMissingError';
    this.message = `The required scopes vs. user accepted scopes don't match.`;
  }
}
